/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Constant from "../../util/constant";

/**
 * A functional component that renders the sidebar content.
 * @param {object} props - The props passed to the component.
 * @returns The JSX elements representing the sidebar content.
 */
const SidebarContent = (props) => {
  const stateRole = window.localStorage.getItem(Constant.LOCALSTORAGEKEYS.LOGINROLE);

  const CLOUDINARY_URL =
    process.env.REACT_APP_CLOUDNARY_URL +
    process.env.REACT_APP_CLOUDNARY_NAME +
    process.env.REACT_APP_CLOUDNARY_SUBFLODER;

  return (
    <>
      <div id="sidebar-menu">
        <div className="navbar-brand-box">
          <Link to="#" className="logo logo-dark">
            <span className="logo-sm">
              <img src={CLOUDINARY_URL + "Logo.png"} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={CLOUDINARY_URL + "Logo.png"} alt="" height="48" />
            </span>
          </Link>
        </div>
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">{props.t("MANAGEMENT")}</li>

          {
            stateRole === "Admin" ?
              <>
                <li className="mm-active">
                  <NavLink
                    to="/noticemanagement"
                    className={({ isActive }) => (isActive ? "active" : "inactive")}
                  >
                    {/* <Link to="/noticemanagement" className="active"> */}
                    <div className="left-menu">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M19.0944 9.03711V5.70378C19.0944 4.78711 18.3444 4.03711 17.4277 4.03711H4.0944C3.17773 4.03711 2.43607 4.78711 2.43607 5.70378V9.03711C3.35273 9.03711 4.0944 9.78711 4.0944 10.7038C4.0944 11.6204 3.35273 12.3704 2.42773 12.3704V15.7038C2.42773 16.6204 3.17773 17.3704 4.0944 17.3704H17.4277C18.3444 17.3704 19.0944 16.6204 19.0944 15.7038V12.3704C18.1777 12.3704 17.4277 11.6204 17.4277 10.7038C17.4277 9.78711 18.1777 9.03711 19.0944 9.03711ZM17.4277 7.82044C16.4361 8.39544 15.7611 9.47878 15.7611 10.7038C15.7611 11.9288 16.4361 13.0121 17.4277 13.5871V15.7038H4.0944V13.5871C5.08607 13.0121 5.76107 11.9288 5.76107 10.7038C5.76107 9.47044 5.0944 8.39544 4.10273 7.82044L4.0944 5.70378H17.4277V7.82044ZM10.7611 12.4704L8.3194 14.0371L9.05273 11.2288L6.81107 9.39544L9.70273 9.22044L10.7611 6.53711L11.8111 9.22878L14.7027 9.40378L12.4611 11.2371L13.2027 14.0371L10.7611 12.4704Z"
                          fill="white"
                        />
                      </svg>
                      <span>{props.t("NOTICES")}</span>
                    </div>
                  </NavLink>
                  {/* </Link> */}
                </li>
                <li>
                  <NavLink
                    to="/depotsManagement"
                    className={({ isActive }) => (isActive ? "active" : "inactive")}
                  >
                    {/* <Link to="/noticemanagement" className="active"> */}
                    <div className="left-menu">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.2617 5.28711V10.2871H18.2617V18.6204H3.26172V6.95378H8.26172V5.28711L10.7617 2.78711L13.2617 5.28711ZM4.92839 16.9538H6.59505V15.2871H4.92839V16.9538ZM6.59505 13.6204H4.92839V11.9538H6.59505V13.6204ZM4.92839 10.2871H6.59505V8.62044H4.92839V10.2871ZM9.92839 16.9538V15.2871H11.5951V16.9538H9.92839ZM9.92839 11.9538V13.6204H11.5951V11.9538H9.92839ZM9.92839 10.2871V8.62044H11.5951V10.2871H9.92839ZM9.92839 5.28711V6.95378H11.5951V5.28711H9.92839ZM16.5951 16.9538H14.9284V15.2871H16.5951V16.9538ZM14.9284 13.6204H16.5951V11.9538H14.9284V13.6204Z"
                          fill="white"
                        />
                      </svg>
                      <span>{props.t("DEPOTS")}</span>
                    </div>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/usersManagement"
                    className={({ isActive }) => (isActive ? "active" : "inactive")}
                  >
                    <div className="left-menu">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.92839 3.20312H16.5951C17.5117 3.20312 18.2617 3.95312 18.2617 4.86979V16.5365C18.2617 17.4531 17.5117 18.2031 16.5951 18.2031H4.92839C4.00339 18.2031 3.26172 17.4531 3.26172 16.5365V4.86979C3.26172 3.95312 4.00339 3.20312 4.92839 3.20312ZM16.5951 4.86979H4.92839V16.5365H16.5951V4.86979ZM10.7617 10.7031C9.38672 10.7031 8.26172 9.57812 8.26172 8.20312C8.26172 6.82812 9.38672 5.70312 10.7617 5.70312C12.1367 5.70312 13.2617 6.82812 13.2617 8.20312C13.2617 9.57812 12.1367 10.7031 10.7617 10.7031ZM9.92839 8.20312C9.92839 7.74479 10.3034 7.36979 10.7617 7.36979C11.2201 7.36979 11.5951 7.74479 11.5951 8.20312C11.5951 8.66146 11.2201 9.03646 10.7617 9.03646C10.3034 9.03646 9.92839 8.66146 9.92839 8.20312ZM5.76172 15.7031V14.4281C5.76172 12.3448 9.07005 11.4448 10.7617 11.4448C12.4534 11.4448 15.7617 12.3448 15.7617 14.4281V15.7031H5.76172ZM10.7617 13.1031C11.8534 13.1031 13.2617 13.5698 13.8367 14.0365H7.68672C8.25339 13.5698 9.67005 13.1031 10.7617 13.1031Z"
                          fill="white"
                        />
                      </svg>
                      <span>{props.t("USERS")}</span>
                    </div>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/noticeType"
                    className={({ isActive }) => (isActive ? "active" : "inactive")}
                  >
                    <div className="left-menu">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Icon">
                          <path
                            id="icon/maps/category_24px"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M5.76237 9.86914L10.3457 2.36914L14.929 9.86914H5.76237ZM11.954 8.20247L10.3457 5.56914L8.72904 8.20247H11.954ZM14.929 11.5358C12.854 11.5358 11.179 13.2108 11.179 15.2858C11.179 17.3608 12.854 19.0358 14.929 19.0358C17.004 19.0358 18.679 17.3608 18.679 15.2858C18.679 13.2108 17.004 11.5358 14.929 11.5358ZM12.8457 15.2858C12.8457 16.4358 13.779 17.3691 14.929 17.3691C16.079 17.3691 17.0124 16.4358 17.0124 15.2858C17.0124 14.1358 16.079 13.2025 14.929 13.2025C13.779 13.2025 12.8457 14.1358 12.8457 15.2858ZM2.8457 18.6191H9.51237V11.9525H2.8457V18.6191ZM7.8457 13.6191H4.51237V16.9525H7.8457V13.6191Z"
                            fill="white"
                          />
                        </g>
                      </svg>

                      <span>{props.t("NOTICE_TYPE")}</span>
                    </div>
                  </NavLink>
                </li>
              </>
              :
              <>
              <li className="mm-active">
                  <NavLink
                    to="/noticemanagement"
                    className={({ isActive }) => (isActive ? "active" : "inactive")}
                  >
                    {/* <Link to="/noticemanagement" className="active"> */}
                    <div className="left-menu">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M19.0944 9.03711V5.70378C19.0944 4.78711 18.3444 4.03711 17.4277 4.03711H4.0944C3.17773 4.03711 2.43607 4.78711 2.43607 5.70378V9.03711C3.35273 9.03711 4.0944 9.78711 4.0944 10.7038C4.0944 11.6204 3.35273 12.3704 2.42773 12.3704V15.7038C2.42773 16.6204 3.17773 17.3704 4.0944 17.3704H17.4277C18.3444 17.3704 19.0944 16.6204 19.0944 15.7038V12.3704C18.1777 12.3704 17.4277 11.6204 17.4277 10.7038C17.4277 9.78711 18.1777 9.03711 19.0944 9.03711ZM17.4277 7.82044C16.4361 8.39544 15.7611 9.47878 15.7611 10.7038C15.7611 11.9288 16.4361 13.0121 17.4277 13.5871V15.7038H4.0944V13.5871C5.08607 13.0121 5.76107 11.9288 5.76107 10.7038C5.76107 9.47044 5.0944 8.39544 4.10273 7.82044L4.0944 5.70378H17.4277V7.82044ZM10.7611 12.4704L8.3194 14.0371L9.05273 11.2288L6.81107 9.39544L9.70273 9.22044L10.7611 6.53711L11.8111 9.22878L14.7027 9.40378L12.4611 11.2371L13.2027 14.0371L10.7611 12.4704Z"
                          fill="white"
                        />
                      </svg>
                      <span>{props.t("NOTICES")}</span>
                    </div>
                  </NavLink>
                  {/* </Link> */}
                </li>
                <li className="mm-active">
                  <NavLink
                    to="/drivermangment"

                    className={({ isActive }) => (isActive ? "active" : "inactive")}

                  >

                    <div className="left-menu">

                      <svg

                        xmlns="http://www.w3.org/2000/svg"

                        width="21"

                        height="20"

                        viewBox="0 0 21 20"

                        fill="none"

                      >

                        <path

                          fillRule="evenodd"

                          clipRule="evenodd"

                          d="M16.5284 4.17492C16.3617 3.68325 15.8951 3.33325 15.3451 3.33325H6.17839C5.62839 3.33325 5.17005 3.68325 4.99505 4.17492L3.26172 9.16658V15.8333C3.26172 16.2916 3.63672 16.6666 4.09505 16.6666H4.92839C5.38672 16.6666 5.76172 16.2916 5.76172 15.8333V14.9999H15.7617V15.8333C15.7617 16.2916 16.1367 16.6666 16.5951 16.6666H17.4284C17.8867 16.6666 18.2617 16.2916 18.2617 15.8333V9.16658L16.5284 4.17492ZM6.47005 4.99992H15.0451L15.9451 7.59159H5.57005L6.47005 4.99992ZM4.92839 13.3333H16.5951V9.16659H4.92839V13.3333ZM7.01172 9.99992C6.32136 9.99992 5.76172 10.5596 5.76172 11.2499C5.76172 11.9403 6.32136 12.4999 7.01172 12.4999C7.70207 12.4999 8.26172 11.9403 8.26172 11.2499C8.26172 10.5596 7.70207 9.99992 7.01172 9.99992ZM13.2617 11.2499C13.2617 10.5596 13.8214 9.99992 14.5117 9.99992C15.2021 9.99992 15.7617 10.5596 15.7617 11.2499C15.7617 11.9403 15.2021 12.4999 14.5117 12.4999C13.8214 12.4999 13.2617 11.9403 13.2617 11.2499Z"

                          fill="white"

                        />

                      </svg>

                      <span>{props.t("DRIVERS")}</span>

                    </div>

                  </NavLink>

                  {/* </Link> */}

                </li>
              </>
          }


        </ul>
      </div>
    </>
  );
};

SidebarContent.propTypes = {
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withTranslation()(SidebarContent);
